var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Creating a Google cloud project...")]),_c('h3',[_vm._v("You will be redirected shortly")]),_c('div',{staticClass:"stage"},[_c('div',{staticClass:"dot-flashing"})])])])])
}]

export { render, staticRenderFns }